
/**
 * Jquery
 */
import jQuery from "jquery";
Object.assign(window, { $: jQuery, jQuery })

/**
 * Lenis
*/
import Lenis from '@studio-freight/lenis'
window.Lenis = Lenis; 

/**
 * Barba.js
*/
import barba from "@barba/core";
window.barba = barba;



/**
 * Lazysizes
 */
import lazySizes from 'lazysizes';
lazySizes.cfg.init = false; // init manuale, v. app.js
lazySizes.cfg.loadMode = 1; // 1 = only load visible elements
window.lazySizes = lazySizes;


/**
 * uikit
 */
import Icons from 'uikit/dist/js/uikit-icons';
import UIkit from 'uikit';
UIkit.use(Icons);
window.UIkit = UIkit;